/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { analyticsDescribe } from "../funcs/analyticsDescribe.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AnalyticsDescribeResult } from "../models/components/analyticsdescriberesult.js";
import {
  AnalyticsDescribeRequest,
  AnalyticsDescribeSecurity,
} from "../models/operations/analyticsdescribe.js";
import { unwrapAsync } from "../types/fp.js";
export type AnalyticsDescribeQueryData = AnalyticsDescribeResult;

export function prefetchAnalyticsDescribe(
  queryClient: QueryClient,
  client$: GramCore,
  request?: AnalyticsDescribeRequest | undefined,
  security?: AnalyticsDescribeSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAnalyticsDescribeQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAnalyticsDescribeQuery(
  client$: GramCore,
  request?: AnalyticsDescribeRequest | undefined,
  security?: AnalyticsDescribeSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AnalyticsDescribeQueryData>;
} {
  return {
    queryKey: queryKeyAnalyticsDescribe({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function analyticsDescribeQueryFn(
      ctx,
    ): Promise<AnalyticsDescribeQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(analyticsDescribe(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAnalyticsDescribe(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "analytics", "describe", parameters];
}
